import { CircleAlert, Info, TriangleAlert } from "lucide-react";

const lookupTypeConfig = (type) => {
  switch (type) {
    case "caution":
      return {
        icon: CircleAlert,
        color: "bg-fail-bg text-danger-ink",
      };
    case "warning":
      return {
        icon: TriangleAlert,
        color: "bg-warning-bg text-warning-fg",
      };
    default:
      return {
        icon: Info,
        color: "bg-surface-muted text-ink",
      };
  }
};

const Callout = ({ type, title, message, centerIcon }) => {
  const { icon: IconComponent, color } = lookupTypeConfig(type);

  return (
    <div
      className={`flex w-full gap-x-2.5 rounded px-4 py-3 text-body-lg ${
        centerIcon ? "items-center" : "items-start"
      } ${color}`}
    >
      <IconComponent
        aria-hidden
        className={`size-4 shrink-0 ${centerIcon ? "" : "mt-0.5"}`}
        strokeWidth={2}
      />

      <div className="flex flex-col text-pretty">
        {title && <div className="font-semibold">{title}</div>}
        {message}
      </div>
    </div>
  );
};

export default Callout;
